import { createMantineTheme } from "./lib/create-mantine-theme";
import { Theme } from "./lib/theme";

export const songdrive_dark: Theme = {
	label: "🎵 Songdrive Dark",
	mantineTheme: createMantineTheme({
		baseHue: 210,
		baseSaturation: 55,
		colors: {
			primary: [
				"#f0f7fa",
				"#e1eff4",
				"#c3dfe9",
				"#a5cfde",
				"#87bfd3",
				"#69afc8",
				"#4b9fbd",
				"#2d8fb2",
				"#0f7fa7",
				"#006f9c",
			],
			secondary: [
				"#f5f0f9",
				"#ebe1f3",
				"#d7c3e7",
				"#c3a5db",
				"#af87cf",
				"#9b69c3",
				"#874bb7",
				"#732dab",
				"#5f0f9f",
				"#4b0093",
			],
			tertiary: [
				"#e8ecf2",
				"#d1d9e5",
				"#a3b3cb",
				"#758db1",
				"#476797",
				"#19417d",
				"#142a4c",
				"#0f1f39",
				"#0a1426",
				"#050a13",
			],
		},
	}),
};
